import { render, staticRenderFns } from "./CmgUpsell.vue?vue&type=template&id=51b85172&scoped=true&lang=pug"
import script from "./cmg-upsell.ts?vue&type=script&lang=ts&external"
export * from "./cmg-upsell.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgUpsell.vue?vue&type=style&index=0&id=51b85172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b85172",
  null
  
)

export default component.exports